import { Link } from "react-router-dom";
import {
  PhoneCall, MessageSquare, Bot, Inbox, Radio, PhoneMissed, HeadphonesIcon,
  ChevronRight, Rocket, Users, Sparkles,
} from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const HUB_TILES = [
  { icon: PhoneCall, title: "AI Receptionist", desc: "Answer every call, capture leads, book appointments, transfer when needed.", to: "/receptionist", testid: "hub-receptionist" },
  { icon: Bot, title: "AI Digital Representative", desc: "One trained business brain across web · voice · phone · WhatsApp · SMS.", to: "/representative", testid: "hub-representative" },
  { icon: MessageSquare, title: "AI Feedback Assistant", desc: "Customer Voice AI — survey, analyze, recommend, improve, measure.", to: "/feedback", testid: "hub-feedback" },
  { icon: Inbox, title: "Unified Inbox", desc: "Voice · SMS · WhatsApp · email · chat — one dashboard per customer.", to: "/lcc", testid: "hub-inbox" },
  { icon: Radio, title: "Communications Center", desc: "Consent, templates, quiet hours, delivery — governance across all channels.", to: "/communications", testid: "hub-comms" },
  { icon: PhoneMissed, title: "Missed-Call Recovery", desc: "Automatic SMS + callback when a call is missed. Turns lost calls into leads.", to: "/missed-calls", testid: "hub-missed" },
  { icon: HeadphonesIcon, title: "Employee Copilot", desc: "Private suggestions to human agents during live conversations.", to: "/copilot", testid: "hub-copilot" },
  { icon: Rocket, title: "Build Your AI Employee", desc: "10-step guided wizard to create, test, and launch a new agent.", to: "/build-agent", testid: "hub-wizard" },
];

export default function VoiceCommunicationHub() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 pt-24 pb-16" data-testid="voice-comm-hub">
        <div className="max-w-6xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-indigo-700">
            <Radio className="w-3.5 h-3.5" /> AI Voice & Communication
          </div>
          <h1 className="mt-2 text-4xl font-bold text-slate-900">WebsiteTech AI Employees</h1>
          <p className="mt-2 text-lg text-slate-600 max-w-2xl italic">Voice, chat and customer-service agents trained for your business.</p>

          <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {HUB_TILES.map((t) => (
              <Link key={t.testid} to={t.to} data-testid={t.testid}
                className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md hover:border-indigo-300 transition group">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-indigo-50 grid place-items-center border border-indigo-100">
                    <t.icon className="w-5 h-5 text-indigo-600" />
                  </div>
                  <div className="flex-1">
                    <div className="font-semibold text-slate-900">{t.title}</div>
                  </div>
                  <ChevronRight className="w-4 h-4 text-slate-400 group-hover:text-indigo-600 transition" />
                </div>
                <div className="mt-3 text-sm text-slate-600 leading-relaxed">{t.desc}</div>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
